export { default as HeroSlider } from './hero-slider';
export { default as BrandsSlider } from './brands-slider';
export { default as CategoriesSlider } from './categories-slider';
export { default as ClientsReviewsSlider } from './clients-reviews-slider';
export { default as GridProductsSlider } from './grid-products-slider';
export { default as ProductsSlider } from './products-slider';
export { default as HomeCategoriesSlider } from './home-categories-slider';
